import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3656c839"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Внимание!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "По данному заказу оплата не доступна. Для проставления статуса «Доставлен» и закрытия накладной подтвердите приём оплаты.", -1))
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "StatusesTable" }
const _hoisted_6 = {
  key: 11,
  class: "invoice__content"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка накладной...", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "content__header" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_15 = { class: "content__body" }
const _hoisted_16 = { class: "content__right-holder" }
const _hoisted_17 = { class: "content__right" }
const _hoisted_18 = { class: "content__right mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold uppercase text-blue-400" }, "Проблемы", -1))
const _hoisted_20 = { id: "print-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wait_list_status_modal = _resolveComponent("wait-list-status-modal")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_invoice_status_row = _resolveComponent("invoice-status-row")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_change_invoice_number = _resolveComponent("change-invoice-number")!
  const _component_save_box_modal = _resolveComponent("save-box-modal")!
  const _component_restore_modal = _resolveComponent("restore-modal")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_invoice_actions_button = _resolveComponent("invoice-actions-button")!
  const _component_ltl_tabs = _resolveComponent("ltl-tabs")!
  const _component_invoice_content = _resolveComponent("invoice-content")!
  const _component_invoice_delivery_history = _resolveComponent("invoice-delivery-history")!
  const _component_invoice_document = _resolveComponent("invoice-document")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.wait_list_state.is_opened)
      ? (_openBlock(), _createBlock(_component_wait_list_status_modal, {
          key: 0,
          order: _ctx.wait_list_state.order,
          loading: _ctx.wait_list_state.is_loading,
          type: 2,
          code: _ctx.state.invoice?.status?.code,
          "is-inventory": "",
          onCancel: _ctx.cancelWaitList,
          onSubmit: _ctx.setWaitListStatus
        }, null, 8, ["order", "loading", "code", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.predict_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          title: "Смена даты",
          scrollable: "",
          class: "large",
          loading: _ctx.predict_state.is_loading,
          onCancel: _ctx.togglePredictDate,
          onConfirm: _ctx.setPredictDate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              placeholder: "Выберите новую дату",
              value: _ctx.predict_state.date,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.predict_state.date) = $event)),
              type: "datetime-local",
              "is-invalid": _ctx.predict_state_form$.date.$error,
              "validation-errors": _ctx.predict_state_form$.date.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.approve_state.is_notification_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 2,
          class: "medium",
          title: "Приём оплаты за заказ",
          loading: false,
          onCancel: _ctx.onCancelApproveNotification,
          onConfirm: _ctx.onConfirmApproveNotification
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, "Сумма: " + _toDisplayString(_ctx.approveNotificationPrice), 1)
          ]),
          _: 1
        }, 8, ["onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.approve_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 3,
          title: "Проставить статус 'Доставлено'",
          scrollable: "",
          class: "large",
          loading: _ctx.approve_state.is_loading,
          onCancel: _ctx.toggleApproveDelivery,
          onConfirm: _ctx.approveDelivery
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              placeholder: "Выберите новую дату",
              value: _ctx.approve_state.deliveredAt,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.approve_state.deliveredAt) = $event)),
              type: "datetime-local",
              "is-invalid": _ctx.approve_state_form$.deliveredAt.$error,
              "validation-errors": _ctx.approve_state_form$.deliveredAt.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_file_reader, {
              class: "mt-2",
              accept: "image/*",
              placeholder: "Файлы",
              multiple: "",
              value: _ctx.approve_state.attachments,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.approve_state.attachments) = $event)),
              "is-invalid": _ctx.approve_state_form$.attachments.$error,
              "validation-errors": _ctx.approve_state_form$.attachments.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              placeholder: "ФИО получателя",
              value: _ctx.approve_state.receiverName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.approve_state.receiverName) = $event)),
              "is-invalid": _ctx.approve_state_form$.receiverName.$error,
              "validation-errors": _ctx.approve_state_form$.receiverName.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.verify_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 4,
          title: "Редактирование верификации",
          scrollable: "",
          class: "medium",
          loading: _ctx.verify_state.is_loading,
          "height-fixed": "",
          onCancel: _ctx.cancelVerify,
          onConfirm: _ctx.submitVerify
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_select, {
              disabled: _ctx.verify_state.is_loading,
              value: _ctx.verify_state.verify,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verify_state.verify) = $event)),
              options: _ctx.VERIFY_OPTIONS,
              searchable: false,
              "select-by": "value"
            }, null, 8, ["disabled", "value", "options"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.previous_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 5,
          title: "Проставить прошлый статус",
          scrollable: "",
          class: "medium",
          loading: _ctx.previous_state.is_loading,
          height: "70%",
          onCancel: _ctx.cancelPreviousState,
          onConfirm: _ctx.setPreviousState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_select, {
              placeholder: "Статусы",
              loading: _ctx.data_state.statuses.is_loading,
              failed: _ctx.data_state.statuses.is_failed,
              "error-text": "При получении списка произошла ошибка",
              options: _ctx.data_state.statuses.list,
              "is-invalid": _ctx.previous_state_form$.code.$error,
              "validation-errors": _ctx.previous_state_form$.code.$errors,
              disabled: _ctx.previous_state.is_loading,
              value: _ctx.previous_state.code,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.previous_state.code) = $event)),
              onRefresh: _ctx.loadStatuses,
              searchable: false,
              "select-by": "code"
            }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "disabled", "value", "onRefresh"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_lo && _ctx.state.statuses_lo.length)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 6,
          class: "xxl StatusesTable",
          title: "Статусы ЛО",
          scrollable: "",
          loading: _ctx.state.is_loading,
          onCancel: _ctx.toggleLo,
          "without-footer": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_new_table, {
                columns: _ctx.COLUMNS,
                rows: _ctx.state.statuses_lo
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_invoice_status_row, {
                    column: column,
                    row: row,
                    "is-invoices": ""
                  }, null, 8, ["column", "row"])
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.change_invoice_number_state.is_opened)
      ? (_openBlock(), _createBlock(_component_change_invoice_number, {
          key: 7,
          loading: _ctx.change_invoice_number_state.is_loading,
          onCancel: _ctx.closeChangeInvoiceNumber,
          onSubmit: _ctx.changeInvoiceNumber
        }, null, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.box_state.is_opened)
      ? (_openBlock(), _createBlock(_component_save_box_modal, {
          key: 8,
          loading: _ctx.box_state.is_loading,
          onCancel: _ctx.closeSaveBox,
          onSubmit: _ctx.saveBox
        }, null, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.restore_state.is_opened)
      ? (_openBlock(), _createBlock(_component_restore_modal, {
          key: 9,
          loading: _ctx.restore_state.is_loading,
          onCancel: _ctx.closeRestore,
          onSubmit: _ctx.restore
        }, null, 8, ["loading", "onCancel", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 10,
          loading: _ctx.state.is_loading,
          text: "При получении накладной произошла ошибка",
          onRefresh: _ctx.loadInvoice
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_8
              ]))
            : (Boolean(_ctx.state.invoice))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_page_title, {
                          title: `Накладная ${
                                    _ctx.state.invoice.invoice_number || '(без номера накладной)'
                                }`
                        }, null, 8, ["title"]),
                        (_ctx.state.invoice && _ctx.state.invoice.status)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: _normalizeClass(`ml-3 small font-bold ${_ctx.getCheapClass}`)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.invoice.status.name), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.invoice && _ctx.state.invoice.isArrested)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 1,
                              class: _normalizeClass(`ml-3 small font-bold red`)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Выдача заблокирована ")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.state.invoice && _ctx.isShowSignedStatus)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 2,
                              class: _normalizeClass(["small ml-3", { 'green': _ctx.state.invoice.isSigned, 'red': !_ctx.state.invoice.isSigned }])
                            }, {
                              default: _withCtx(() => [
                                (_ctx.state.invoice.isSigned)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Подписан")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("Не подписан")
                                    ], 64))
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (Boolean(_ctx.state.invoice))
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              class: "primary text small",
                              onClick: _ctx.goToOrder
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Перейти к заказу ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_the_button, {
                          class: "second text small",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.go(-1)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14,
                            _createTextVNode(" Назад ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_invoice_actions_button, {
                          invoice: _ctx.state.invoice,
                          "delivery-history": _ctx.delivery_history.list,
                          loading: _ctx.state.is_print_loading,
                          "box-loading": _ctx.state.is_box_saving,
                          "restore-loading": _ctx.restore_state.is_loading,
                          "partial-return": Boolean(_ctx.settings_state.partial_return),
                          "properties-loading": _ctx.properties_state.is_loading,
                          onDeclaredPrice: _ctx.toggleDeclaredPrice,
                          onChangeInvoiceNumber: _ctx.openChangeInvoiceNumber,
                          onPrint: _ctx.printInvoice,
                          onRestore: _ctx.manageRestore,
                          onSaveBox: _ctx.onSaveBox,
                          onPredictDate: _ctx.togglePredictDate,
                          onWaitList: _ctx.startWaitList,
                          onVerify: _ctx.startVerify,
                          onPreviousStatus: _ctx.startPreviousStatus,
                          onApproveDelivery: _ctx.toggleApproveDelivery,
                          onProperties: _ctx.updateInvoiceProperties,
                          onArrested: _ctx.loadInfo
                        }, null, 8, ["invoice", "delivery-history", "loading", "box-loading", "restore-loading", "partial-return", "properties-loading", "onDeclaredPrice", "onChangeInvoiceNumber", "onPrint", "onRestore", "onSaveBox", "onPredictDate", "onWaitList", "onVerify", "onPreviousStatus", "onApproveDelivery", "onProperties", "onArrested"])
                      ])
                    ])
                  ]),
                  _createVNode(_component_ltl_tabs, {
                    class: "mt-3",
                    value: _ctx.state.currentTab,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.currentTab) = $event)),
                    invoice: _ctx.state.invoice,
                    transit: _ctx.state.transit,
                    "is-shortcoming": Boolean(_ctx.state.is_shortcoming)
                  }, null, 8, ["value", "invoice", "transit", "is-shortcoming"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_invoice_content, {
                      invoice: _ctx.state.invoice,
                      pvz: _ctx.state.pvz,
                      "is-pvz-failed": _ctx.state.is_pvz_failed,
                      "is-pvz-loading": _ctx.state.is_pvz_loading,
                      "client-sla-date": _ctx.delivery_history.client_sla_date,
                      "current-tab": _ctx.state.currentTab,
                      "status-history": _ctx.state.status_history,
                      trip: _ctx.state.trip,
                      transit: _ctx.state.transit,
                      "is-trips-loading": _ctx.state.is_trips_loading,
                      "delivery-courier": _ctx.state.deliveryCourier,
                      "take-courier": _ctx.state.takeCourier,
                      "transcript-loading": _ctx.transcript_state.is_loading,
                      "transcript-created": _ctx.transcript_state.is_created,
                      "transcript-id": _ctx.transcript_state.transcript_id,
                      "cash-payment-loading": _ctx.cash_payment_state.is_loading,
                      "cash-payment-failed": _ctx.cash_payment_state.is_failed,
                      "cash-payment-item": _ctx.cash_payment_state.item,
                      onReloadPvz: _ctx.loadPVZByID,
                      onShortcoming: _ctx.setShortcoming,
                      onDeleteStatus: _ctx.loadInfo
                    }, null, 8, ["invoice", "pvz", "is-pvz-failed", "is-pvz-loading", "client-sla-date", "current-tab", "status-history", "trip", "transit", "is-trips-loading", "delivery-courier", "take-courier", "transcript-loading", "transcript-created", "transcript-id", "cash-payment-loading", "cash-payment-failed", "cash-payment-item", "onReloadPvz", "onShortcoming", "onDeleteStatus"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_invoice_delivery_history, {
                          loading: _ctx.delivery_history.is_loading,
                          failed: _ctx.delivery_history.is_failed,
                          "invoice-number": _ctx.state.invoice.invoice_number,
                          history: _ctx.delivery_history.list,
                          "take-time-slot-time": _ctx.state.invoice.takeTimeSlotTime,
                          "delivery-time-slot-time": _ctx.state.invoice.deliveryTimeSlotTime,
                          onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadInvoiceStatuses(_ctx.state.invoice.invoice_number)))
                        }, null, 8, ["loading", "failed", "invoice-number", "history", "take-time-slot-time", "delivery-time-slot-time"]),
                        (_ctx.state.statuses_lo.length)
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              onClick: _ctx.toggleLo,
                              class: "primary small mt-5 w-full"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Статусы ЛО ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("p", null, _toDisplayString(_ctx.getProblems), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", _hoisted_20, [
      (Boolean(_ctx.state.invoice_print))
        ? (_openBlock(), _createBlock(_component_invoice_document, {
            key: 0,
            invoice: _ctx.state.invoice_print,
            class: "InvoiceDocument--dotted",
            style: {"padding-bottom":"10px"}
          }, null, 8, ["invoice"]))
        : _createCommentVNode("", true),
      (Boolean(_ctx.state.invoice_print))
        ? (_openBlock(), _createBlock(_component_invoice_document, {
            key: 1,
            invoice: _ctx.state.invoice_print,
            style: {"padding-top":"6px"}
          }, null, 8, ["invoice"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_ctx.state.is_on_set_declared_price)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            class: "large SubmitOrder",
            title: "Внесение объявленной стоимости",
            loading: _ctx.state.is_loading,
            onCancel: _ctx.toggleDeclaredPrice,
            onConfirm: _ctx.handleDeclaredPrice
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_input, {
                placeholder: "Наименование груза",
                value: _ctx.state.cargoName,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.cargoName) = $event)),
                "is-invalid": _ctx.state_form$.cargoName.$error,
                "validation-errors": _ctx.state_form$.cargoName.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                placeholder: "Объявленная стоимость",
                value: _ctx.state.declaredPrice,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.declaredPrice) = $event)),
                "is-invalid": _ctx.state_form$.declaredPrice.$error,
                "validation-errors": _ctx.state_form$.declaredPrice.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _: 1
          }, 8, ["loading", "onCancel", "onConfirm"]))
        : _createCommentVNode("", true)
    ])
  ]))
}